import { render, staticRenderFns } from "./user_table.vue?vue&type=template&id=028525bc&scoped=true&"
import script from "./user_table.vue?vue&type=script&lang=js&"
export * from "./user_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028525bc",
  null
  
)

export default component.exports